import React from "react";
import { CheckCircleOutlined, HomeOutlined, LoadingOutlined, StopOutlined, UserOutlined, WarningOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, Form, Input, Modal, Select, Space, Table, Tabs, Tooltip } from "antd";
import "./supply_slip_return.css";
import { IoAddCircleSharp, IoPrintSharp } from "react-icons/io5";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { HiOutlineDocumentCheck } from "react-icons/hi2";
import { FaPlusCircle } from "react-icons/fa";
import { TiDelete } from "react-icons/ti";
import DataSupplySlip from "./data_supply_slip";
import withSupplySlipReturnLogic, { SupplySlipReturnProps } from "./hoc_supply_slip_return";
import LisItemSupplySlip from "./list_item_supply_slip";

const SupplySlipReturn: React.FC<SupplySlipReturnProps> = ({
    form,
    tableData,
    columns,
    pagination,
    rowSelection,
    loading,
    onTableChange,
    autosaveStatus,
    isDataSupplySlipModalVisible,
    isAddItemModalVisible,
    handleOpenDataSupplySlip,
    handleCloseDataSupplySlip,
    handleCloseAddItem,
    handleSelectSupplySlip,
    supplySlipNo,
    handleVoid,
    handleNew,
    status,
    handleDelete,
    handleAdd,
    handleAddItemToTable,
    handleSubmit,
    selectedRowKeys,
    lockedFields,
    onFieldFocus,
    onFieldBlur,
    onFormValuesChange,
    getLockProps
}) => {
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };
    const Printbtn = IoPrintSharp as React.ComponentType<any>;
    const Voidbtn = IoIosCloseCircleOutline as React.ComponentType<any>;
    const Submitbtn = HiOutlineDocumentCheck as React.ComponentType<any>;
    const Newbtn = FaPlusCircle as React.ComponentType<any>;
    const Addbtn = IoAddCircleSharp as React.ComponentType<any>;
    const Deletebtn = TiDelete as React.ComponentType<any>;
    const isFormDisabled = status !== "Draft" && status !== "1";

    return (

        <div id="iuyj" style={transformStyle}>
            <div className="gjs-grid-row" id="i9ix">
                <div className="gjs-grid-column" id="iu9k">
                    <Breadcrumb
                        items={[
                            {
                                title: <HomeOutlined />,
                            },
                            {
                                href: "#/dashboard/data_supply_slip_return",
                                title: (
                                    <>
                                        <span>Data Supply Slip Return</span>
                                    </>
                                ),
                            },
                            {
                                title: "Supply Slip Return",
                            },
                        ]}
                    />
                </div>
            </div>

            <div className="gjs-grid-row" id="iuzn9">
                <div className="gjs-grid-column" id="ie1da">
                    <Button
                        className="gr-button"
                        onClick={handleNew}
                    >
                        <Newbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        New
                    </Button>
                    <Button
                        className="gr-button"
                        onClick={handleSubmit}
                        disabled={status !== "Draft" && status !== "1"}
                    >
                        <Submitbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        Submit
                    </Button>
                    <Button className="gr-button"
                        onClick={handleVoid}
                        disabled={status !== "Draft" && status !== "1"}
                    >
                        <Voidbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        Void
                    </Button>
                    <Button className="gr-button">
                        <Printbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        Print
                    </Button>
                    <Space style={{ marginLeft: '10px' }}>
                        {autosaveStatus === 'processing' && (
                            <Tooltip title="Autosave sedang berjalan...">
                                <LoadingOutlined style={{ color: '#1890ff' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'error' && (
                            <Tooltip title="Autosave bermasalah. Periksa konsol untuk detail.">
                                <WarningOutlined style={{ color: '#ff4d4f' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'stopped' && (
                            <Tooltip title="Autosave Stopped">
                                <StopOutlined style={{ color: '#bfbfbf' }} />
                            </Tooltip>
                        )}
                        {autosaveStatus === 'idle' && (
                            <Tooltip title="Autosave berhasil.">
                                <CheckCircleOutlined style={{ color: '#52c41a' }} />
                            </Tooltip>
                        )}
                    </Space>
                </div>
            </div>

            <div className="gjs-grid-row" id="iicil">
                <div className="gjs-grid-column" id="im9x">
                    <Form
                        form={form}
                        layout="horizontal"
                        style={{ maxWidth: 440 }}
                        labelCol={{ style: { width: '150px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-request"
                        onValuesChange={onFormValuesChange}
                        disabled={isFormDisabled}
                    >
                        <Form.Item
                            label="Status"
                            name='status'
                            style={{
                                marginBottom: "5px",
                            }}
                            {...getLockProps("status")}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="SP Return No"
                            name='supply_slip_return_no'
                            style={{
                                marginBottom: "5px",
                            }}
                            {...getLockProps("supply_slip_return_no")}
                        >
                            <Input
                                placeholder=""
                                readOnly
                                disabled={isFormDisabled || !!lockedFields?.["supply_slip_return_no"]}
                                onFocus={() => onFieldFocus("supply_slip_return_no")}
                                onBlur={() => onFieldBlur("supply_slip_return_no")}
                            />
                        </Form.Item>
                        <Form.Item
                            label="SP Return Date"
                            name='supply_slip_return_date'
                            style={{
                                marginBottom: "5px",
                            }}
                            {...getLockProps("supply_slip_return_date")}
                        >
                            <Input
                                placeholder=""
                                readOnly
                                disabled={isFormDisabled || !!lockedFields?.["supply_slip_return_date"]}
                                onFocus={() => onFieldFocus("supply_slip_return_date")}
                                onBlur={() => onFieldBlur("supply_slip_return_date")}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Work Order No"
                            style={{ marginBottom: "5px" }}
                            {...getLockProps("work_order_no")}
                        >
                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                <Form.Item
                                    name="work_order_no"
                                    noStyle
                                    style={{ width: "100%" }}
                                    rules={[{ required: true, message: 'Required !' }]}
                                >
                                    <Input
                                        style={{ width: "100%" }}
                                        readOnly
                                        disabled={isFormDisabled || !!lockedFields?.["work_order_no"]}
                                        onFocus={() => onFieldFocus("work_order_no")}
                                        onBlur={() => onFieldBlur("work_order_no")}
                                    />
                                </Form.Item>
                                <Button
                                    type="primary"
                                    id="data_supply_slip"
                                    onClick={handleOpenDataSupplySlip}
                                    disabled={isFormDisabled || !!form.getFieldValue('work_order_no') || !!lockedFields?.["work_order_no"]} // ⚠️: disable tombol pencarian modal
                                    icon={
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: "40px", height: "20px" }}>
                                            <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                            <path fillRule="evenodd" d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z" clipRule="evenodd" />
                                            <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                        </svg>}
                                />
                            </div>
                        </Form.Item>
                        <Form.Item
                            label="Work Order Date"
                            name='work_order_date'
                            style={{
                                marginBottom: "5px",
                            }}
                            {...getLockProps("work_order_date")}
                        >
                            <Input
                                placeholder=""
                                readOnly
                                disabled={isFormDisabled || !!lockedFields?.["work_order_date"]}
                                onFocus={() => onFieldFocus("work_order_date")}
                                onBlur={() => onFieldBlur("work_order_date")}
                            />
                        </Form.Item>
                    </Form>
                </div>
                <div className="gjs-grid-column" id="idqh1">
                    <Form
                        form={form}
                        layout="horizontal"
                        style={{ maxWidth: 400 }}
                        labelCol={{ style: { width: '150px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-request"
                        onValuesChange={onFormValuesChange}
                        disabled={isFormDisabled}
                    >
                        <Form.Item
                            label="No. Polisi"
                            name='no_polisi'
                            style={{
                                marginBottom: "5px",
                            }}
                            {...getLockProps("no_polisi")}
                        >
                            <Input
                                placeholder=""
                                readOnly
                                disabled={isFormDisabled || !!lockedFields?.["no_polisi"]}
                                onFocus={() => onFieldFocus("no_polisi")}
                                onBlur={() => onFieldBlur("no_polisi")}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Warehouse"
                            name='warehouse'
                            style={{
                                marginBottom: "5px",
                            }}
                            {...getLockProps("warehouse")}
                        >
                            <Form.Item
                                name="warehouse_name_display"
                                noStyle
                            >
                                <Input
                                    placeholder=""
                                    readOnly
                                    disabled={isFormDisabled || !!lockedFields?.["warehouse"]}
                                />
                            </Form.Item>
                        </Form.Item>
                    </Form>
                </div>
            </div>
            <div className="gjs-grid-row" id="it32">
                <div className="gjs-grid-column" id="ilx7">
                    <Button
                        className="gr-button"
                        onClick={handleAdd}
                        disabled={(status !== "Draft" && status !== "1") || !!lockedFields?.["add_item_modal"]}
                    >
                        <Addbtn style={{ width: '1em', height: '1em', marginRight: '8px' }} id="list_item_supply_slip" />
                        Add Item
                    </Button>
                    <Button
                        className="gr-button"
                        onClick={handleDelete}
                        disabled={(status !== "Draft" && status !== "1") || !selectedRowKeys || selectedRowKeys.length === 0 || selectedRowKeys.some((key: React.Key) => !!lockedFields?.[`row_${key}`] || !!lockedFields?.[`qty_return_${key}`] || !!lockedFields?.[`remarks_${key}`])}
                    >
                        <Deletebtn style={{ width: '1em', height: '1em', marginRight: '8px' }} />
                        Delete
                    </Button>
                    <Tabs
                        defaultActiveKey="1"
                        items={[
                            {
                                key: '1',
                                label: 'Spareparts Detail',
                                children: (
                                    <Table
                                        rowSelection={rowSelection}
                                        columns={columns}
                                        dataSource={tableData}
                                        scroll={{ x: 1300 }}
                                        pagination={pagination}
                                        loading={loading}
                                        onChange={onTableChange}
                                        rowClassName={(record: any) => (lockedFields?.[`qty_return_${record.key}`] || lockedFields?.[`remarks_${record.key}`] || lockedFields?.[`row_${record.key}`] ? "table-row-locked" : "")}
                                    />
                                ),
                            },
                        ]}
                    />

                </div>
            </div>
            <div className="gjs-grid-row" id="it322">
                <div className="gjs-grid-column" id="ilx77">
                </div>
            </div>
            <Modal
                title="Data Supply Slip"
                open={isDataSupplySlipModalVisible}
                onCancel={handleCloseDataSupplySlip}
                footer={null}
                width={1000}
            >
                <DataSupplySlip onSelect={handleSelectSupplySlip} />
            </Modal>
            <Modal
                title="List Item Supply Slip"
                open={isAddItemModalVisible}
                onCancel={handleCloseAddItem}
                footer={null}
                width={1000}
            >
                <LisItemSupplySlip
                    workOrderNo={form.getFieldValue('work_order_no')}
                    existingItemCodes={tableData.map((item: any) => item.item_code)}
                    onOk={handleAddItemToTable}
                    onCancel={handleCloseAddItem}
                />
            </Modal>
        </div>
    );
};

export default withSupplySlipReturnLogic(SupplySlipReturn);
